import { useEffect, useState } from 'react';

export default function useAuth() {
  const [ready, setReady] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const t = localStorage.getItem('qtalk_token');
    if (!t || t === 'undefined' || t === 'null') {
      window.location.href = '/login';
    } else {
      setToken(t);
      setReady(true);
    }
  }, []);

  return { ready, token };
}
